/**
 * **Best Western Scandinavia**
 *
 * @exports partnership_442
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
        * @memberOf module:partnership_442
        */
    partnership.getId = function getId() {
        return '442';
    };
    /**
        * @memberOf module:partnership_442
        */
    partnership.check = function check() {
        return window.location.hostname.includes('bestwestern');
    };
    /**
        * @memberOf module:partnership_442
        */
    partnership.getSiteId = function getSiteId() {
        const hotelIdDl = thn.dataLayerHelper.get('event_info.hotel_id');
        const validPath = !!window.location.pathname.match(/hotel\/\d+|booking|confirm/);
        let result;
        if (hotelIdDl && validPath) {
            result = {
                externalId: hotelIdDl,
            };
        }
        else {
            result = {
                accountKey: '33E5F1A10DFAB8F76C1EC273D9B0B99F',
            };
        }
        return result;
    };
    /**
     * @memberOf module:partnership_442
     */
    partnership.boot = function boot() {
        if (!window.dataLayer) {
            return;
        }
        partnership.shutdown = thn.generateCallbackQueue();
        const refreshPartnership = thn.debounce(thn.siteCheck, 700);
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
            if (message.event_info?.hotel_id || message.page_info?.page_url) {
                refreshPartnership();
            }
        }, true);
        partnership.shutdown = function () {
            dataLayerHelper.unlisten();
            dataLayerHelper = null;
        };
    };
    return partnership;
}

export { factory };
